"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.weightInputSchema = exports.default = void 0;
var WeightInput_1 = require("./WeightInput");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(WeightInput_1).default; } });
Object.defineProperty(exports, "weightInputSchema", { enumerable: true, get: function () { return WeightInput_1.weightInputSchema; } });
//# sourceMappingURL=index.js.map